import React, { useState, useEffect, useContext } from 'react';
import './DeploymentResourceForm.css';
import { getResourceDetailsById, createResourceDeploy, getIncidentRegions, facilityListByRegionId, getVehiclesByIncident, deployvehicle, availdeplvehicle } from '../../../../Services/EndPoints';
import { getData, postDataWithBody } from '../../../../Services/Services';
import Select from 'react-select';
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { ThemeContext } from '../../../..';


const DeploymentResourceForm = ({ resouceData, onResourceDetailsUpdate, onLocateOnMap }) => {
   const [formData, setFormData] = useState({
      searchResource: '',
      resourceId: '',
      resourceName: '',
      incidentName: '',
      agencyName: '',
      agencyWebsite: '',
      agencyContacts: [],
      totalQuantity: '',
      availableQuantity: '',
      requiredQuantity: '',
      deployQuantity: '',
      locationName: '',
      latitude: '',
      longitude: '',
      locateOnMap: false,
      facilityNames: '',
      incidentId: '',
      sopInstanceId: '',
      vehicleIds: [],
      rsrc_activity_id: ''
   });
   const [loading, setLoading] = useState(false);
   const [error, setError] = useState(null);
   const [contactOptions, setContactOptions] = useState([]);
   const [quantityError, setQuantityError] = useState('');
   const [deploySuccess, setDeploySuccess] = useState(false);
   const navigate = useNavigate();
   const [incidentRegions, setIncidentRegions] = useState([]);
   const { theme } = useContext(ThemeContext);
   const [facilityNames, setFacilityNames] = useState([]);
   const [isDeploying, setIsDeploying] = useState(false);
   const [vehicleOptions, setVehicleOptions] = useState([]);


   const handleFacilityNamesChange = (e) => {
      setFormData(prev => ({
         ...prev,
         facilityNames: e.target.value
      }));
   };

   const handleVehicleChange = (e) => {
      const selected = Array.from(
         e.target.selectedOptions,
         option => option.value
      );

      setFormData(prev => ({
         ...prev,
         vehicleIds: selected
      }));
   };

   const fetchVehicles = async (incidentId) => {
      try {
           const vehiclesResponse = await getData(availdeplvehicle);

       

         console.log("Vehicles Response", vehiclesResponse);

         const formattedVehicles = vehiclesResponse.map(vehicle => ({
            value: vehicle.id,
            label: `${vehicle.vehicleNumber || ''} `.trim()
         }));

         setVehicleOptions(formattedVehicles);
      } catch (err) {
         console.error('Error fetching vehicles:', err);
         setVehicleOptions([]);
      }
   };

   const OptionWithCheckbox = ({ innerProps, isSelected, label }) => (
      <div {...innerProps} className="d-flex p-2" style={{
         backgroundColor: isSelected ? '#f0f0f0' : '#fff',
         color: '#333',
         cursor: 'pointer',
         alignItems: 'flex-start',
         minHeight: '40px'
      }}>
         <div style={{
            marginRight: '12px',
            marginTop: '2px',
            flexShrink: 0
         }}>
            <input
               type="checkbox"
               checked={isSelected}
               readOnly
               style={{
                  verticalAlign: 'top',
                  cursor: 'pointer',
                  width: '16px',
                  height: '16px'
               }}
            />
         </div>
         <div style={{
            flex: 1,
            paddingTop: '1px'
         }}>
            {label.split('\n').map((line, i) => (
               <div key={i}>{line}</div>
            ))}
         </div>
      </div>
   );


   const MultiValue = ({ data }) => (
      <span className="mr-1" style={{ color: theme === 'dark' ? 'white' : '#333' }}>{data.label}</span>
   );


   const MultiValueContainer = ({ children }) => (
      <div className="d-flex flex-wrap align-items-center" style={{ maxWidth: '100%', gap: '4px' }}>
         {React.Children.map(children, (child, index) => (
            <>
               {child}
               {index < React.Children.count(children) - 1 && (
                  <span style={{
                     color: '#7c8091',
                     fontSize: '14px',
                     padding: '0 2px'
                  }}>|</span>
               )}
            </>
         ))}
      </div>
   );


   const handleResourceSelect = async (e) => {
      const selectedResourceId = e.target.value;

      setFormData(prev => ({
         ...prev,
         searchResource: selectedResourceId
      }));

      if (!selectedResourceId) {
         setFormData(prev => ({
            ...prev,
            incidentName: '',
            incidentId: '',
            sopInstanceId: '',
            resourceName: '',
            resourceId: '',
            agencyName: '',
            agencyWebsite: '',
            agencyContacts: [],
            totalQuantity: '',
            availableQuantity: '',
            requiredQuantity: '',
            deployQuantity: '',
            locationName: '',
            latitude: '',
            longitude: '',
            vehicleId: '',
            rsrc_activity_id: ''
         }));
         setContactOptions([]);
         setVehicleOptions([]);
         setQuantityError('');
         return;
      }


      const selectedResource = resouceData.find(resource => resource.id.toString() === selectedResourceId);

      try {
         setLoading(true);
         setError(null);

         const payload = {
            incidentId: selectedResource.incidentId,
            ids: [parseInt(selectedResourceId)],
            required_quantity: selectedResource.required_quantity,
            sop_master_id: selectedResource.sop_master_id,
            severity_id: selectedResource.severity_id
         };
         const resourceDetailsResponse = await postDataWithBody(getResourceDetailsById, payload, {});
         console.log("Resource Details Response", resourceDetailsResponse);


         // Second API call - get incident regions      
         const incidentRegionsResponse = await getData(`${getIncidentRegions}${selectedResource.incidentId}`);
         console.log("Incident Regions Response", incidentRegionsResponse);

         // Store the incident regions data
         setIncidentRegions(incidentRegionsResponse);
         const resourceDetails = resourceDetailsResponse[0];

         // Fetch vehicles for this incident
        if (selectedResource.incidentId && resourceDetails.rsrc_activity_id === "Transportation") {
            await fetchVehicles(selectedResource.incidentId);
         } else {
            setVehicleOptions([]); // Clear vehicles if not Transportation
         }

         

         const contacts = resourceDetails.resource_contact_map?.map(contactMap => {
            const contactDetails = contactMap.contact_details || {};
            const contactName = contactDetails.name || '';
            const contactPhone = contactDetails.phone1 || '';
            const jobTitle = contactDetails.job_title_config?.value || '';

            let contactText = '';
            if (contactName && jobTitle && contactPhone) {
               contactText = `${contactName}, ${jobTitle}, ${contactPhone}`;
            } else if (contactName && contactPhone) {
               contactText = `${contactName}, ${contactPhone}`;
            } else {
               contactText = contactPhone || '';
            }

            return {
               value: contactMap.id,
               label: contactText,
               contactId: contactMap.contact_id
            };
         }) || [];


         if (contacts.length === 0 && resourceDetails.agency_details?.phone) {
            contacts.push({
               value: 'agency_phone',
               label: resourceDetails.agency_details.phone,
               contactId: null
            });
         }

         const regionId = resourceDetails.resource_region_map?.[0]?.region_id;
         if (regionId) {
            try {
               const facilityResponse = await getData(`${facilityListByRegionId}${regionId}`);
               console.log("Facility Response", facilityResponse);

               const formattedFacilities = facilityResponse.map(facility => ({
                  value: facility.id,
                  label: facility.name
               }));

               setFacilityNames(formattedFacilities);

               // Set the first facility as default if available
               if (formattedFacilities.length > 0) {
                  setFormData(prev => ({
                     ...prev,
                     facilityNames: formattedFacilities[0].value
                  }));
               }
            } catch (err) {
               console.error('Error fetching facilities:', err);
               setFacilityNames([]);
            }
         } else {
            setFacilityNames([]);
         }


         setContactOptions(contacts);


         const formattedResourceName = `${resourceDetails.name || selectedResource?.name || ''} (${resourceDetails.agency_details?.name || ''})`;


         const updatedFormData = {
            ...formData,
            searchResource: selectedResourceId,
            resourceId: resourceDetails.id || '',
            incidentId: selectedResource.incidentId,
            sopInstanceId: selectedResource.sopInstanceId,
            resourceName: resourceDetails.name || selectedResource?.name || '',
            incidentName: resourceDetails.incident_name || '',
            agencyName: resourceDetails.agency_details?.name || '',
            agencyWebsite: resourceDetails.agency_details?.website || '',
            agencyContacts: contacts.length > 0 ? [contacts[0]] : [],
            totalQuantity: resourceDetails.total_quantity || '',
            availableQuantity: resourceDetails.available_quantity !== undefined ? resourceDetails.available_quantity : '',
            requiredQuantity: selectedResource.required_quantity !== undefined ? selectedResource.required_quantity : '',
            deployQuantity: resourceDetails.deploy_quantity !== undefined ? resourceDetails.deploy_quantity.toString() : '',
            locationName: resourceDetails.facility_name || '',
            latitude: '',
            longitude: '',
            vehicleId: '',
            rsrc_activity_id: resourceDetails.rsrc_activity_id || ''
         };

         setFormData(updatedFormData);
         setQuantityError('');

         if (onResourceDetailsUpdate) {
            onResourceDetailsUpdate(resourceDetails, incidentRegionsResponse);
         }
      } catch (err) {
         setError('Failed to fetch resource details');
         console.error('Error fetching resource details:', err);
      } finally {
         setLoading(false);
      }
   };


   const handleContactChange = (selectedOptions) => {
      setFormData(prev => ({
         ...prev,
         agencyContacts: selectedOptions || []
      }));
   };

   const handleInputChange = (e) => {
      const { name, value } = e.target;

      if (name === "deployQuantity") {
         const qty = parseInt(value) || 0;
         const available = parseInt(formData.availableQuantity) || 0;
         const required = parseInt(formData.requiredQuantity) || 0;
         const maxAllowed = required > 0 ? Math.min(required, available) : available;

         if (qty > maxAllowed) {
            setQuantityError(
              required > 0
                ? `Cannot exceed (${required})`
                : `Cannot exceed available quantity (${available})`
            );
         } else if (qty <= 0) {
            setQuantityError("Deploy quantity must be greater than 0");
         } else {
            setQuantityError("");
         }

         // Reset vehicles when quantity changes
         setFormData(prev => ({ ...prev, vehicleIds: [] }));
      }

      setFormData(prev => ({ ...prev, [name]: value }));
   };
   // const handleInputChange = (e) => {
   //    const { name, value, type, checked } = e.target;

   //    if (name === 'deployQuantity') {
   //       const intValue = Math.floor(Number(value));
   //       if (value.includes('.') || isNaN(intValue)) {
   //          setQuantityError('Please enter a whole number');
   //          return;
   //       }
   //       const availableQty = parseInt(formData.availableQuantity) || 0;
   //       const deployQty = parseInt(value) || 0;

   //       if (deployQty > availableQty) {
   //          setQuantityError(`Deploy quantity cannot exceed available quantity (${availableQty})`);
   //       } else if (deployQty <= 0) {
   //          setQuantityError('Deploy quantity must be greater than 0');
   //       } else {
   //          setQuantityError('');
   //       }
   //    }

   //    setFormData(prev => ({
   //       ...prev,
   //       [name]: type === 'checkbox' ? checked : value
   //    }));
   // };


   const handleLocateOnMap = () => {
      console.log('Locate on map clicked');
      if (formData.resourceId) {
         onLocateOnMap(incidentRegions);
      } else {
         toast.warning("Please select a resource first", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
         });
      }
   };

   const handleDeploy = async () => {
      if (quantityError) return;

      const deployQty = parseInt(formData.deployQuantity) || 0;
      if (formData.rsrc_activity_id === "Transportation") {
         const selectedVehicleCount = formData.vehicleIds.length;

         if (selectedVehicleCount !== deployQty) {
            toast.error(`Please select exactly ${deployQty} vehicle(s)`, {
               position: toast.POSITION.TOP_CENTER,
               autoClose: 2000
            });
            return;
         }
      }

      if (!formData.facilityNames) {
         toast.error("Please select deploy facility");
         return;
      }

      const payload = {
         resourceId: parseInt(formData.resourceId),
         deploy_quantity: deployQty,
         deploy_facility_id: parseInt(formData.facilityNames),
         incident_id: parseInt(formData.incidentId),
         sop_instance_id: formData.sopInstanceId ? parseInt(formData.sopInstanceId) : null,
         // vehicle_ids: formData.vehicleIds.map(id => parseInt(id)), // ✅ CHANGED
         resource_deploy_contact_map: formData.agencyContacts
            .filter(c => c.contactId)
            .map(c => ({ contact_id: c.contactId }))
      };


      try {
         setIsDeploying(true);
         setLoading(true);

         const response = await postDataWithBody(createResourceDeploy, payload, {});

         if (response.status === "success") {
            toast.success("Resource deployed successfully", {
               position: toast.POSITION.TOP_CENTER,
               autoClose: 2000
            });
            const payload1 = {
               vehicleIds: formData.vehicleIds.map(id => parseInt(id)),
               incidentId: parseInt(formData.incidentId),
               resourceId: parseInt(formData.resourceId),
               deployFacilityId: parseInt(formData.facilityNames),
               resourceDepolyId: response.id
            }
            await postDataWithBody(deployvehicle, payload1, {})
            navigate("/resource-assign-list");
         } else {
            toast.error(response.msg || "Deployment failed");
         }

      } catch (err) {
         toast.error("Failed to deploy resource");
      } finally {
         setLoading(false);
         setIsDeploying(false);
      }
   };

   // const handleDeploy = async () => {
   //    if (quantityError) {
   //       return;
   //    }
   //    setIsDeploying(true);
   //    const availableQty = parseInt(formData.availableQuantity) || 0;
   //    const deployQty = parseInt(formData.deployQuantity) || 0;

   //    if (deployQty > availableQty) {
   //       setQuantityError(`Deploy quantity cannot exceed available quantity (${availableQty})`);
   //       setIsDeploying(false);
   //       return;
   //    }

   //    if (deployQty <= 0) {
   //       setQuantityError('Deploy quantity must be greater than 0');
   //       setIsDeploying(false);
   //       return;
   //    }

   //    if (!formData.facilityNames) {
   //       toast.error("Please select a deploy facility", {
   //          position: toast.POSITION.TOP_CENTER,
   //          autoClose: 2000,
   //       });
   //       setIsDeploying(false);
   //       return;
   //    }

   //    const facilityId = parseInt(formData.facilityNames);
   //    if (isNaN(facilityId)) {
   //       toast.error("Invalid facility selection", {
   //          position: toast.POSITION.TOP_CENTER,
   //          autoClose: 2000,
   //       });
   //       setIsDeploying(false);
   //       return;
   //    }

   //    // Prepare the payload
   //    const payload = {
   //       resourceId: parseInt(formData.resourceId),
   //       deploy_quantity: deployQty,
   //       deploy_facility_id: facilityId,
   //       incident_id: parseInt(formData.incidentId),
   //       vehicle_ids: formData.vehicleIds.map(id => parseInt(id)),
   //       resource_deploy_contact_map: formData.agencyContacts
   //          .filter(contact => contact.contactId)
   //          .map(contact => ({
   //             contact_id: contact.contactId
   //          }))
   //    };


   //    try {
   //       setLoading(true);
   //       setError(null);

   //       // Call the deployment endpoint
   //       const response = await postDataWithBody(createResourceDeploy, payload, {});

   //       console.log('Deployment successful:', response);


   //       // Show toast based on response status
   //       if (response.status === "success") {
   //          toast.success(response.msg || "Resource deployed successfully", {
   //             position: toast.POSITION.TOP_CENTER,
   //             autoClose: 2000,
   //          });
   //          setLoading(false);
   //          setTimeout(() => {
   //             navigate("/resource-assign-list");
   //          }, 3000);
   //       } else {
   //          toast.error(response.msg || "Resource already deployed", {
   //             position: toast.POSITION.TOP_CENTER,
   //             autoClose: 2000,
   //          });
   //          setIsDeploying(false);
   //       }

   //    } catch (err) {
   //       console.error('Error deploying resource:', err);
   //       toast.error(err.response?.data?.msg || "Failed to deploy resource", {
   //          position: toast.POSITION.TOP_CENTER,
   //          autoClose: 2000,
   //       });
   //       setIsDeploying(false);
   //    } finally {
   //       setLoading(false);
   //    }
   // };



   const inputReadOnly = {
      borderRadius: "0.1rem",
      border: "1px solid #7c8091",
      backgroundColor: "var(--secondary-color)",
      color: "#7c8091",
      fontSize: "12px",
      fontWeight: 200
   };


   const customSelectStyles = {
      control: (provided, state) => ({
         ...provided,
         backgroundColor: "none",
         borderColor: state.isFocused ? '#4d90fe' : '#dddde0ff',
         boxShadow: state.isFocused ? '0 0 0 1px #4d90fe' : null,
         '&:hover': {
            borderColor: '#4d90fe'
         },
         minHeight: '29px',
         height: '29px',
         borderRadius: '4px',
         cursor: 'text',
         color: 'white',
         borderRadius: "2px"
      }),
      valueContainer: (provided) => ({
         ...provided,
         flexWrap: 'nowrap',
         overflow: 'hidden',
         textOverflow: 'ellipsis',
         whiteSpace: 'nowrap',
         cursor: 'text',
         padding: '0 8px',
         input: {
            color: 'white !important',
            cursor: 'text !important'
         }
      }),
      multiValue: (provided) => ({
         ...provided,
         backgroundColor: 'transparent',
         border: 'none',
         margin: '0 2px',
         padding: 0
      }),
      multiValueLabel: (provided) => ({
         ...provided,
         color: 'inherit',
         padding: 0,
         cursor: 'text'
      }),
      multiValueRemove: () => ({
         display: 'none'
      }),
      input: (provided) => ({
         ...provided,
         color: 'white',
         width: 'auto',
         cursor: 'text !important',
         margin: 0,
         padding: 0
      }),
      placeholder: (provided) => ({
         ...provided,
         color: 'rgba(163, 160, 160, 0.7)',
         margin: 0
      }),
      singleValue: (provided) => ({
         ...provided,
         color: 'white',
         margin: 0
      }),
      menu: (provided) => ({
         ...provided,
         zIndex: 9999,
         backgroundColor: '#fff',
         color: '#333'
      }),
      option: (provided, state) => ({
         ...provided,
         backgroundColor: state.isSelected ? '#f0f0f0' : '#fff',
         color: '#333',
         '&:hover': {
            backgroundColor: '#e0e0e0'
         }
      }),
      dropdownIndicator: (provided) => ({
         ...provided,
         padding: '4px'
      }),
      clearIndicator: (provided) => ({
         ...provided,
         padding: '4px'
      })
   };


   return (
      <div className="resource-form-container" style={{
         backgroundColor: theme === "light" ? "#ffffff" : "#1f2a44",
         padding: "1rem",
         borderRadius: "8px",
      }}>
         <h3 className="resource-details" style={{ color: theme === 'dark' ? 'white' : '#333' }}>Resource Details</h3>

         {error && <div className="alert alert-danger">{error}</div>}
         {deploySuccess && <div className="alert alert-success">Resource deployed successfully!</div>}

         <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2rem' }}>
            <div style={{ width: '400px' }}>
               <select
                  name="searchResource"
                  value={formData.searchResource}
                  onChange={handleResourceSelect}
                  className={theme == "light" ? "search-input1" : "search-input"}
                  style={{ width: "400px" }}
                  disabled={loading}
               >
                  <option value="">Select Resource...</option>
                  {resouceData && resouceData.map(resource => (
                     <option key={resource.id} value={resource.id}>
                        {`${resource.name} (${resource.agency_name})`}
                     </option>
                  ))}
               </select>
            </div>
         </div>

         <div className="text-center">
            <button className="btn rd-locate-map-btn" onClick={handleLocateOnMap}>
               Locate On Map
            </button>
         </div>


         <div className="row" style={{ marginTop: '2rem' }}>
            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <label className="rd-label" htmlFor="incidentName">Incident Name:</label>
                  <input
                     readOnly
                     type="text"
                     className="rd-form-control"
                     id="incidentName"
                     name="incidentName"
                     value={formData.incidentName}
                     onChange={handleInputChange}
                     style={inputReadOnly}
                  />
               </div>
            </div>

            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <label className="rd-label" htmlFor="resourceName">Resource Name:</label>
                  <input
                     readOnly
                     type="text"
                     className="rd-form-control"
                     id="resourceName"
                     name="resourceName"
                     value={formData.resourceName}
                     onChange={handleInputChange}
                     style={inputReadOnly}
                  />
               </div>
            </div>


            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <label className="rd-label" htmlFor="agencyName">Agency Name:</label>
                  <input
                     readOnly
                     type="text"
                     className="rd-form-control"
                     id="agencyName"
                     name="agencyName"
                     value={formData.agencyName}
                     onChange={handleInputChange}
                     style={inputReadOnly}
                  />
               </div>
            </div>


            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                     <label className="rd-label" htmlFor="locationName">Resource Facility Name:</label>
                  </div>
                  <input
                     readOnly
                     type="text"
                     className="rd-form-control"
                     id="locationName"
                     name="locationName"
                     value={formData.locationName}
                     onChange={handleInputChange}
                     style={inputReadOnly}
                  />
               </div>
            </div>


            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <label className="rd-label" htmlFor="agencyContacts">Agency Contact:</label>
                  <Select
                     isMulti
                     name="agencyContacts"
                     options={contactOptions}
                     className={theme === "light" ? "rd-custom-select__control1" : "rd-custom-select__control"}
                     value={formData.agencyContacts}
                     onChange={handleContactChange}
                     placeholder="Select contacts..."
                     components={{
                        Option: OptionWithCheckbox,
                        MultiValue,
                        MultiValueContainer
                     }}
                     hideSelectedOptions={false}
                     closeMenuOnSelect={false}
                     styles={customSelectStyles}
                     isClearable={false}
                     backspaceRemovesValue={false}
                  />
               </div>
            </div>


            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <label className="rd-label" htmlFor="totalQuantity">Total Quantity:</label>
                  <input
                     readOnly
                     type="text"
                     className="rd-form-control"
                     id="totalQuantity"
                     name="totalQuantity"
                     value={formData.totalQuantity}
                     onChange={handleInputChange}
                     style={inputReadOnly}
                  />
               </div>
            </div>


            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <label className="rd-label" htmlFor="availableQuantity">Available Quantity:</label>
                  <input
                     readOnly
                     type="text"
                     className="rd-form-control"
                     id="availableQuantity"
                     name="availableQuantity"
                     value={formData.availableQuantity}
                     onChange={handleInputChange}
                     style={inputReadOnly}
                  />
                  {parseInt(formData.availableQuantity) === 0 && (
                     <div className="text-danger small mt-1">No resources available for deployment</div>
                  )}
               </div>
            </div>


            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <label className="rd-label" htmlFor="deployQuantity">Deploy Quantity: <span style={{ color: "red" }}>*</span></label>
                  <input
                     type="number"
                     className={theme === "light" ? "rd-form-control1" : "rd-form-control"}
                     id="deployQuantity"
                     name="deployQuantity"
                     value={formData.deployQuantity}
                     onChange={handleInputChange}
                     min="1"
                     max={
                       formData.requiredQuantity
                         ? Math.min(parseInt(formData.requiredQuantity) || 0, parseInt(formData.availableQuantity) || 0)
                         : formData.availableQuantity
                     }
                     step="1"
                     onKeyDown={(e) => {
                        if (e.key === '.' || e.key === ',' || e.key === '-' || e.key === '+' || e.key === 'e' || e.key === 'E') {
                           e.preventDefault();
                        }
                     }}
                     disabled={parseInt(formData.availableQuantity) === 0}
                     style={{
                        ...(parseInt(formData.availableQuantity) === 0 && {
                           borderColor: '#7c8091',
                           cursor: 'not-allowed'
                        })
                     }}
                  />
                  {formData.requiredQuantity && (
                    <div style={{ fontSize: "11px", color: "#6c757d", marginTop: "3px" }}>
                      Max: {Math.min(parseInt(formData.requiredQuantity) || 0, parseInt(formData.availableQuantity) || 0)}
                    </div>
                  )}
                  {quantityError && (
                     <div className="text-danger small mt-1">{quantityError}</div>
                  )}
                  {parseInt(formData.availableQuantity) === 0 && (
                     <div className="text-danger small mt-1">No resources available for deployment</div>
                  )}
               </div>
            </div>

            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <label className="rd-label" htmlFor="facilityNames">Deploy Facility Name: <span style={{ color: "red" }}>*</span></label>
                  <select
                     className={theme === "light" ? "rd-form-control1" : "rd-form-control"}
                     id="facilityNames"
                     name="facilityNames"
                     value={formData.facilityNames}
                     onChange={handleFacilityNamesChange}
                  >
                     <option value="">Select a category</option>
                     {facilityNames.map(facility => (
                        <option key={facility.value} value={facility.value}>
                           {facility.label}
                        </option>
                     ))}
                  </select>
               </div>
            </div>
 {formData.rsrc_activity_id === "Transportation" && (
            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                     <label className="rd-label mb-0">
                        Select Vehicles <span style={{ color: 'red' }}>*</span>
                     </label>
                     <div className="d-flex align-items-center">
                        {formData.deployQuantity && (
                           <span className="badge mr-2" style={{
                              backgroundColor: formData.vehicleIds.length === parseInt(formData.deployQuantity) ? '#28a745' :
                                 formData.vehicleIds.length > parseInt(formData.deployQuantity) ? '#dc3545' : '#ffc107',
                              color: 'white',
                              fontSize: '0.8em',
                              padding: '3px 10px',
                              borderRadius: '10px',
                              fontWeight: '500'
                           }}>
                              {formData.vehicleIds.length}/{formData.deployQuantity}
                           </span>
                        )}
                     </div>
                  </div>

                  <div className="vehicle-selection-container" style={{
                     border: '1px solid #7c8091',
                     borderRadius: '4px',
                     padding: '8px',
                     maxHeight: '250px',
                     overflowY: 'auto',
                     backgroundColor: theme === 'dark' ? '#2a3042' : '#f8f9fa'
                  }}>
                     {vehicleOptions.length === 0 ? (
                        <div className="text-center p-3 text-muted">
                           No vehicles available for this incident
                        </div>
                     ) : (
                        <>
                           {/* Header with Select All checkbox */}
                           <div className="d-flex align-items-center mb-3 pb-2" style={{
                              borderBottom: '1px solid #dee2e6',
                              paddingBottom: '8px'
                           }}>
                              <div
                                 className="custom-checkbox mr-3"
                                 style={{
                                    width: '20px',
                                    height: '20px',
                                    border: `2px solid ${formData.vehicleIds.length > 0 ? '#007bff' : '#adb5bd'}`,
                                    borderRadius: '4px',
                                    backgroundColor: formData.vehicleIds.length > 0 ? '#007bff' : 'transparent',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0,
                                    cursor: formData.deployQuantity ? 'pointer' : 'not-allowed',
                                    opacity: !formData.deployQuantity ? 0.5 : 1
                                 }}
                                 onClick={() => {
                                    if (!formData.deployQuantity) return;

                                    const deployQty = parseInt(formData.deployQuantity);
                                    const maxToSelect = Math.min(deployQty, vehicleOptions.length);

                                    if (formData.vehicleIds.length >= maxToSelect) {
                                       // Clear all if already selected max
                                       setFormData(prev => ({ ...prev, vehicleIds: [] }));
                                    } else {
                                       // Select vehicles up to deploy quantity
                                       const selectedIds = vehicleOptions
                                          .slice(0, maxToSelect)
                                          .map(v => v.value.toString());

                                       setFormData(prev => ({
                                          ...prev,
                                          vehicleIds: selectedIds
                                       }));
                                    }
                                 }}
                              >
                                 {formData.vehicleIds.length > 0 && (
                                    <svg
                                       width="12"
                                       height="12"
                                       viewBox="0 0 12 12"
                                       fill="none"
                                       xmlns="http://www.w3.org/2000/svg"
                                       style={{ pointerEvents: 'none' }}
                                    >
                                       <path
                                          d="M10 3L4.5 8.5L2 6"
                                          stroke="white"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                       />
                                    </svg>
                                 )}
                              </div>
                              <div style={{ flex: 1, padding: '2px' }}>
                                 <div style={{
                                    fontWeight: '500',
                                    color: theme === 'dark' ? '#e9ecef' : '#495057',
                                    fontSize: '0.8rem'
                                 }}>
                                    Select All
                                 </div>
                                 <div style={{
                                    fontSize: '0.75em',
                                    color: theme === 'dark' ? '#adb5bd' : '#6c757d'
                                 }}>
                                    {formData.deployQuantity
                                       ? `Click to select first ${Math.min(parseInt(formData.deployQuantity), vehicleOptions.length)} vehicles`
                                       : 'Enter deploy quantity first'}
                                 </div>
                              </div>
                              {/* <div style={{ 
              fontSize: '0.75em',
              color: theme === 'dark' ? '#adb5bd' : '#6c757d',
              fontWeight: '500'
            }}>
              {formData.deployQuantity 
                ? `${Math.min(parseInt(formData.deployQuantity), vehicleOptions.length)} vehicles max`
                : ''}
            </div> */}
                           </div>

                           {/* <div className="mb-2" style={{ padding: '0 4px' }}>
            <small className="text-muted">
              {formData.deployQuantity 
                ? `Select exactly ${formData.deployQuantity} vehicle(s). ${vehicleOptions.length} available.`
                : 'Enter deploy quantity first'}
            </small>
          </div>
           */}
                           {/* Vehicles List with Checkboxes */}
                           {vehicleOptions.map(vehicle => {
                              const isSelected = formData.vehicleIds.includes(vehicle.value.toString());
                              const deployQty = parseInt(formData.deployQuantity) || 0;
                              const currentCount = formData.vehicleIds.length;

                              // Disable if:
                              // 1. No deploy quantity entered
                              // 2. Already selected required number and this one is not selected
                              const isDisabled = !formData.deployQuantity ||
                                 (!isSelected && currentCount >= deployQty);

                              return (
                                 <div
                                    key={vehicle.value}
                                    className="vehicle-option p-2 mb-1"
                                    style={{
                                       display: 'flex',
                                       alignItems: 'center',
                                       border: `1px solid ${isSelected ? '#007bff' : '#dee2e6'}`,
                                       borderRadius: '4px',
                                       backgroundColor: isSelected
                                          ? (theme === 'dark' ? 'rgba(0, 123, 255, 0.2)' : 'rgba(0, 123, 255, 0.1)')
                                          : 'transparent',
                                       cursor: isDisabled && !isSelected ? 'not-allowed' : 'pointer',
                                       opacity: isDisabled && !isSelected ? 0.5 : 1,
                                       transition: 'all 0.2s'
                                    }}
                                    onClick={() => {
                                       if (isDisabled && !isSelected) return;

                                       let newVehicleIds;
                                       if (isSelected) {
                                          // Remove if already selected
                                          newVehicleIds = formData.vehicleIds.filter(id => id !== vehicle.value.toString());
                                       } else {
                                          // Add if not selected and we have capacity
                                          if (formData.vehicleIds.length >= deployQty) return;
                                          newVehicleIds = [...formData.vehicleIds, vehicle.value.toString()];
                                       }

                                       setFormData(prev => ({
                                          ...prev,
                                          vehicleIds: newVehicleIds
                                       }));
                                    }}
                                 >
                                    {/* Vehicle Checkbox */}
                                    <div
                                       className="custom-checkbox mr-3"
                                       style={{
                                          width: '20px',
                                          height: '20px',
                                          border: `2px solid ${isSelected ? '#007bff' : '#adb5bd'}`,
                                          borderRadius: '4px',
                                          backgroundColor: isSelected ? '#007bff' : 'transparent',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          flexShrink: 0,
                                          cursor: 'inherit'
                                       }}
                                    >
                                       {isSelected && (
                                          <svg
                                             width="12"
                                             height="12"
                                             viewBox="0 0 12 12"
                                             fill="none"
                                             xmlns="http://www.w3.org/2000/svg"
                                             style={{ pointerEvents: 'none' }}
                                          >
                                             <path
                                                d="M10 3L4.5 8.5L2 6"
                                                stroke="white"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                             />
                                          </svg>
                                       )}
                                    </div>

                                    {/* Vehicle Info */}
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                       <div style={{
                                          fontWeight: isSelected ? '600' : '400',
                                          color: theme === 'dark'
                                             ? (isSelected ? '#e9ecef' : '#ced4da')
                                             : (isSelected ? '#007bff' : '#495057'),
                                          fontSize: '0.8rem',
                                          marginBottom: '2px',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          padding: '2px'
                                       }}>
                                          {vehicle.label}
                                       </div>
                                       {/* <div style={{ 
                    fontSize: '0.8em', 
                    color: theme === 'dark' ? '#adb5bd' : '#6c757d'
                  }}>
                    ID: {vehicle.value}
                  </div> */}
                                    </div>

                                    {/* Selection Number */}
                                    {isSelected && (
                                       <div style={{
                                          marginLeft: '8px',
                                          backgroundColor: '#28a745',
                                          color: 'white',
                                          fontSize: '0.75em',
                                          fontWeight: '600',
                                          padding: '2px 8px',
                                          borderRadius: '10px',
                                          minWidth: '28px',
                                          textAlign: 'center'
                                       }}>
                                          {formData.vehicleIds.indexOf(vehicle.value.toString()) + 1}
                                       </div>
                                    )}
                                 </div>
                              );
                           })}
                        </>
                     )}
                  </div>

                  {/* {formData.deployQuantity && (
      <div className="mt-3">
      
        <div className="mb-3">
          {formData.vehicleIds.length === parseInt(formData.deployQuantity) ? (
            <div className="d-flex align-items-center" style={{ color: '#28a745' }}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="mr-1">
                <circle cx="8" cy="8" r="7" fill="#28a745" />
                <path d="M5 8L7 10L11 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <small>All {formData.deployQuantity} vehicles selected. Ready to deploy.</small>
            </div>
          ) : formData.vehicleIds.length > parseInt(formData.deployQuantity) ? (
            <div className="d-flex align-items-center" style={{ color: '#dc3545' }}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="mr-1">
                <circle cx="8" cy="8" r="7" fill="#dc3545" />
                <path d="M5 5L11 11M11 5L5 11" stroke="white" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              <small>Too many selected. Please select only {formData.deployQuantity} vehicles.</small>
            </div>
          ) : (
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center" style={{ color: '#ffc107' }}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="mr-1">
                  <circle cx="8" cy="8" r="7" fill="#ffc107" />
                  <path d="M8 4V9M8 12H8.01" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                <small>
                  Select {parseInt(formData.deployQuantity) - formData.vehicleIds.length} more vehicle(s)
                </small>
              </div>
              
              <div className="btn-group btn-group-sm">
                {[1, 2, 3, 4].map(num => (
                  parseInt(formData.deployQuantity) >= num && vehicleOptions.length >= num && (
                    <button
                      key={num}
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => {
                        const selectedIds = vehicleOptions
                          .slice(0, num)
                          .map(v => v.value.toString());
                        
                        setFormData(prev => ({ ...prev, vehicleIds: selectedIds }));
                      }}
                      style={{
                        fontSize: '0.75rem',
                        padding: '2px 8px',
                        borderColor: theme === 'dark' ? '#6c757d' : '#dee2e6',
                        color: theme === 'dark' ? '#e9ecef' : '#495057'
                      }}
                    >
                      Select {num}
                    </button>
                  )
                ))}
              </div>
            </div>
          )}
        </div>

      
        {formData.vehicleIds.length > 0 && (
          <div className="mt-2">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div>
                <small className="text-muted">Selected Vehicles:</small>
                <small className="ml-2" style={{ 
                  color: theme === 'dark' ? '#adb5bd' : '#6c757d',
                  fontWeight: '500'
                }}>
                  {formData.vehicleIds.length} of {formData.deployQuantity}
                </small>
              </div>
              <button
                type="button"
                className="btn btn-sm btn-link p-0"
                onClick={() => setFormData(prev => ({ ...prev, vehicleIds: [] }))}
                style={{
                  fontSize: '0.75rem',
                  textDecoration: 'none',
                  color: theme === 'dark' ? '#adb5bd' : '#6c757d'
                }}
              >
                Clear all
              </button>
            </div>
            
            <div style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
              gap: '8px',
              padding: '10px',
              backgroundColor: theme === 'dark' ? 'rgba(0,0,0,0.1)' : '#f8f9fa',
              borderRadius: '6px',
              border: `1px solid ${theme === 'dark' ? '#495057' : '#dee2e6'}`
            }}>
              {formData.vehicleIds.map((id, index) => {
                const vehicle = vehicleOptions.find(v => v.value.toString() === id);
                return vehicle ? (
                  <div
                    key={id}
                    className="d-flex align-items-center"
                    style={{
                      backgroundColor: theme === 'dark' ? '#495057' : '#e9ecef',
                      padding: '6px 10px',
                      borderRadius: '6px',
                      border: '1px solid #dee2e6'
                    }}
                  >
                    <div style={{
                      backgroundColor: '#007bff',
                      color: 'white',
                      width: '24px',
                      height: '24px',
                      borderRadius: '4px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '0.75rem',
                      fontWeight: 'bold',
                      marginRight: '8px',
                      flexShrink: 0
                    }}>
                      {index + 1}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ 
                        fontSize: '0.85rem',
                        fontWeight: '500',
                        color: theme === 'dark' ? '#e9ecef' : '#495057',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}>
                        {vehicle.label}
                      </div>
                      <div style={{ 
                        fontSize: '0.7rem',
                        color: theme === 'dark' ? '#adb5bd' : '#6c757d'
                      }}>
                        ID: {id}
                      </div>
                    </div>
                    <button
                      type="button"
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#dc3545',
                        cursor: 'pointer',
                        fontSize: '16px',
                        padding: '0 4px',
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '4px',
                        flexShrink: 0,
                        marginLeft: '4px'
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setFormData(prev => ({
                          ...prev,
                          vehicleIds: prev.vehicleIds.filter(vid => vid !== id)
                        }));
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(220, 53, 69, 0.1)'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                      ×
                    </button>
                  </div>
                ) : null;
              })}
            </div>
          </div>
        )}
      </div>
    )} */}
               </div>
            </div>
)}
         </div>

 
         <div className="text-center" style={{ marginTop: "1rem" }}>
            <button
               className="btn rd-locate-map-btn"
               onClick={handleDeploy}
               disabled={
                  !!quantityError ||
                  !formData.deployQuantity ||
                  !formData.facilityNames ||
                  loading ||
                  formData.availableQuantity === '0' ||
                  parseInt(formData.availableQuantity) === 0 ||
                  isDeploying
               }
            >
               {loading ? 'Deploying...' : 'Deploy'}
            </button>
         </div>
      </div>
   );
};


export default DeploymentResourceForm;